import React from "react";
import { IoMoon, IoSunny } from "react-icons/io5";
import { useTheme } from './ThemeContext.jsx';
import "./StyleTheme.css";

const ThemeModal = ({ isOpen, onClose }) => {
  const { theme, toggleTheme } = useTheme();

  if (!isOpen) return null;

  const selectTheme = (nextTheme) => {
    toggleTheme(nextTheme);
    onClose();
  };

  return (
    <div className="fb-theme-modal__overlay" onClick={onClose}>
      <div
        className="fb-theme-modal__content"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="fb-theme-modal__heading">
          <h3 className="fb-theme-modal__title">Appearance</h3>
          <p>Choose a look for FriendlyBets.</p>
        </div>
        <div className="fb-theme-modal__options fb-theme-modal__options--two">
          <button
            type="button"
            className={`fb-theme-modal__option ${theme === "light" ? "is-active" : ""}`}
            onClick={() => selectTheme("light")}
            aria-pressed={theme === "light"}
          >
            <span className="fb-theme-modal__swatch fb-theme-modal__swatch--light"><IoSunny /></span>
            <span><b>Light</b><small>Clean and bright</small></span>
          </button>
          <button
            type="button"
            className={`fb-theme-modal__option ${theme === "dark" ? "is-active" : ""}`}
            onClick={() => selectTheme("dark")}
            aria-pressed={theme === "dark"}
          >
            <span className="fb-theme-modal__swatch fb-theme-modal__swatch--dark"><IoMoon /></span>
            <span><b>Dark</b><small>Easy on the eyes</small></span>
          </button>
        </div>
        <button type="button" className="fb-theme-modal__close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ThemeModal;